// This is the current (V2) Unbox safety flow. The original V1 implementation
// is kept for reference at packages/frontend/src/pages/safety-beta.
import { AlertTriangle, CheckCircle, ShieldZap } from "@untitledui/icons";
import { PageLayout } from "@/components/page-layout";
import { MonitoringBadge } from "./components/MonitoringBadge";
import { NeedsAttentionCard } from "./components/NeedsAttentionCard";
import { PerformanceSection } from "./components/PerformanceSection";
import { SummaryCard } from "./components/SummaryCard";

export const SafetyOverview = () => (
  <PageLayout
    title="Safety Overview"
    subtitle="Last-30-day view of risks and resolutions across creator content."
    icon={ShieldZap}
    callToAction={<MonitoringBadge />}
    contentGap="gap-12"
    backgroundColor="linear-gradient(180deg, #ade6ff42 0%, #c3a5f03d 28%, #FFF 55%)"
  >
    <NeedsAttentionCard />

    <div className="flex gap-8 w-full items-start">
      <SummaryCard icon={AlertTriangle} title="Risks" variant="risks" />
      <SummaryCard icon={CheckCircle} title="Resolution" variant="resolution" />
    </div>

    <PerformanceSection />
  </PageLayout>
);
